module.exports = __webpack_public_path__ + "img/refund.6a1c7e3b.png";